/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import routes from '../../../config/routes'
import { toFormatPhoneComplete } from '../../../lib/format'
import Avatar from '../../commons/Avatar/Avatar'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Card from '../../commons/Card/Card'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import { USER_STATUS_TYPE } from '../../../constants/types'
import styles from './peoplePersonalData.module.scss'

const PeoplePersonalData = ({
  match: {
    params: { id }
  }
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState([
    {
      id: 1,
      title: 'Pessoas',
      path: routes.people.list.path
    }
  ])
  const detail = useSelector((store) => store.supervisedReducer.detail)
  const statusConfirmed = {
    label: 'Confirmado',
    color: 'quaternary'
  }

  const statusEmail =
    detail.status === 1 ? USER_STATUS_TYPE[8] : statusConfirmed

  useEffect(() => {
    setBreadcrumbs([
      ...breadcrumbs,
      {
        id: 2,
        title: 'Detalhes',
        path: routes.people.detail.generate(id)
      },
      {
        id: 3,
        title: 'Informações pessoais'
      }
    ])
  }, [id])

  return (
    <DefaultLayout>
      {detail && (
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Text color="gray" size="lg" variation="dark" extraBold>
                Dados de contato
              </Text>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Breadcrumb items={breadcrumbs} />
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={12} lg={6}>
              <Card className={styles.card}>
                <Flex column>
                  <Flex alignItems="center">
                    <Avatar image={null} title={detail.name} size="medium" />
                    <Text
                      color="gray"
                      variation="light"
                      size="md"
                      margin="0px 0px 0px 10px"
                    >
                      {detail.name}
                    </Text>
                  </Flex>
                  <Text
                    color="gray"
                    variation="dark"
                    size="md"
                    bold
                    margin="10px 0px 0px 0px"
                  >
                    Informações pessoais
                  </Text>
                </Flex>
              </Card>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <Card className={styles.card}>
                <Text margin="26px 0px" color="gray" variation="dark" bold>
                  E-mail
                </Text>
                <Row justify="between">
                  <Col lg={6}>
                    <Text size="xs" color="gray" variation="dark" font="custom">
                      {detail.email}
                    </Text>
                  </Col>
                  <Col lg={6} style={{ textAlign: 'right' }}>
                    <Text
                      size="xxs"
                      value={statusEmail.label}
                      color={statusEmail.color}
                      variation={statusEmail.variation}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          {detail.phoneNumberCell && (
            <Row justify="end">
              <Col sm={12} lg={6}>
                <Card className={styles.card}>
                  <Text margin="26px 0px" color="gray" variation="dark" bold>
                    Alterar telefone
                  </Text>
                  <Row justify="between">
                    <Col lg={6}>
                      <Text
                        size="xs"
                        color="gray"
                        variation="dark"
                        font="custom"
                      >
                        {toFormatPhoneComplete(detail.phoneNumberCell)}
                      </Text>
                    </Col>

                    <Col lg={6} style={{ textAlign: 'right' }}>
                      <Text
                        size="xxs"
                        value={statusConfirmed.label}
                        color={statusConfirmed.color}
                        variation={statusConfirmed.variation}
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      )}
    </DefaultLayout>
  )
}

PeoplePersonalData.defaultProps = {
  match: {
    params: {
      id: undefined
    }
  }
}

PeoplePersonalData.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
}
export default PeoplePersonalData
